import React from "react";
import { PlatformAssignmentRequests } from "@components/Request";

export default function RequestIndex() {
  return <PlatformAssignmentRequests />;
}
